export default "__VITE_ASSET__DQdJFLf0__"